import React, { useEffect, useState } from "react"
import UIFooter from "@ecom/ui/components/Footer"
import { AppLink } from "@ecom/ui/components/AppLink"
import * as styles from "./footer.module.scss"

import { defaultCopyright, defaultSocialLinks } from "./helpers"

export type FooterProps = {
  shortText?: string
  phones?: string[]
  copyright?: React.ReactNode
  withPhone?: boolean
  socialLinks?: any
  storeLinks?: any
}

const classes = {
  footer: "content-visibility-auto",
}

export default function Footer({
  phones = ["8 (800) 100-77-72"],
  shortText,
  copyright = defaultCopyright,
  withPhone,
  socialLinks = defaultSocialLinks,
  storeLinks,
}: FooterProps) {
  const [phoneDelay, setPhoneDelay] = useState(false)

  useEffect(() => {
    setPhoneDelay(true)
  }, [])

  let ShortText

  if (shortText) {
    ShortText = (
      <>
        <span dangerouslySetInnerHTML={{ __html: shortText }} id="ligal" />
        {copyright}
        <div className={styles.cookie}>
          Этот сайт использует cookie-файлы для хранения данных.
          <br className="d-none d-md-block" /> Продолжая использование сайта вы соглашаетесь с&nbsp;
          <AppLink
            href="https://scb.ru/about/pages/cookie-policy"
            className={styles.websitePolicy}
            target="_blank"
            rel="noopener noreferrer"
          >
            Политикой
          </AppLink>
        </div>
      </>
    )
  } else {
    ShortText = (
      <>
        {copyright}
        <div className={styles.cookie}>
          Этот сайт использует cookie-файлы для хранения данных.
          <br className="d-none d-md-block" /> Продолжая использование сайта вы соглашаетесь с&nbsp;
          <AppLink
            href="https://scb.ru/about/pages/cookie-policy"
            className={styles.websitePolicy}
            target="_blank"
            rel="noopener noreferrer"
          >
            Политикой
          </AppLink>
        </div>
      </>
    )
  }

  return (
    <UIFooter
      shortText={ShortText}
      phone={phones}
      withPhone={phoneDelay && withPhone}
      socialLinks={socialLinks}
      storeLinks={storeLinks}
      classes={classes}
    />
  )
}
